"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactPlacesAutocomplete = _interopRequireDefault(require("react-places-autocomplete"));

var _Icons = _interopRequireDefault(require("./Icons"));

var _TooltipCoachmark = _interopRequireDefault(require("./TooltipCoachmark"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var TextField = function TextField(props) {
  var _useState = (0, _react.useState)("fieldClass-" + Math.floor(Math.random() * 100000000)),
      _useState2 = _slicedToArray(_useState, 2),
      fieldClass = _useState2[0],
      setFieldClass = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isFocused = _useState4[0],
      setIsFocused = _useState4[1];

  var ref = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (isFocused) {
      var _document$querySelect;

      (_document$querySelect = document.querySelector(".".concat(fieldClass))) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.focus();
    }
  }, [isFocused]);

  var placeholder = props.placeholder,
      label = props.label,
      valid = props.valid,
      message = props.message,
      className = props.className,
      style = props.style,
      id = props.id,
      autoSelectOnFocus = props.autoSelectOnFocus,
      fieldStyle = props.fieldStyle,
      width = props.width,
      onChange = props.onChange,
      timeoutOptions = props.timeoutOptions,
      customValue = props.customValue,
      rest = _objectWithoutProperties(props, ["placeholder", "label", "valid", "message", "className", "style", "id", "autoSelectOnFocus", "fieldStyle", "width", "onChange", "timeoutOptions", "customValue"]);

  function onChangeHandler(e) {
    onChange(e);

    if (timeoutOptions) {
      var _e$currentTarget = e.currentTarget,
          name = _e$currentTarget.name,
          value = _e$currentTarget.value;
      var callback = timeoutOptions.callback ? timeoutOptions.callback : function () {};
      var time = timeoutOptions.time ? timeoutOptions.time : 1000;
      clearInterval(ref.current);
      ref.current = setTimeout(function () {
        callback(name, value);
      }, time);
    }
  }

  function focus(e) {
    setIsFocused(true);
  }

  if (props.autoSelectOnFocus) {
    rest.onFocus = function (event) {
      event.target.select();
    };
  }

  var classes = (0, _classnames["default"])("input-field", valid, props.fieldStyle, {
    "filled": props.value,
    "location": props.type === "location",
    "disabled": props.disabled,
    "showCustomValue": !isFocused && customValue
  }, className); // WARNING : Location type uses google places api, we need api key and the onChange Gives the value back only.

  var fieldClassToUse = customValue && !isFocused ? "customInput" : fieldClass;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "field-component"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes,
    style: style,
    id: id
  }, label && /*#__PURE__*/_react["default"].createElement("label", {
    className: "field-placeholder"
  }, label), props.type === "location" && /*#__PURE__*/_react["default"].createElement(_reactPlacesAutocomplete["default"], {
    googleLogo: false,
    onSelect: function onSelect(e) {
      props.onChange(e, true);
    },
    inputProps: {
      tabIndex: props.tabIndex,
      value: props.value,
      onChange: onChange,
      placeholder: placeholder,
      autoComplete: props.autoComplete
    },
    classNames: {
      root: 'suggestive-field-container',
      input: (0, _classnames["default"])('suggestive-input', fieldClassToUse),
      autocompleteContainer: 'suggestions-list'
    }
  }), !["location", "area"].includes(props.type) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, customValue && /*#__PURE__*/_react["default"].createElement("div", {
    onClick: focus,
    onBlur: function onBlur() {
      setIsFocused(false);
    }
  }, !isFocused && /*#__PURE__*/_react["default"].createElement("div", {
    className: "customInput"
  }, customValue), /*#__PURE__*/_react["default"].createElement("input", _extends({
    placeholder: placeholder,
    className: fieldClassToUse,
    style: {
      width: width
    },
    onChange: onChangeHandler
  }, rest))), !customValue && /*#__PURE__*/_react["default"].createElement("input", _extends({
    placeholder: placeholder,
    className: fieldClassToUse,
    style: {
      width: width
    },
    onChange: onChangeHandler
  }, rest))), props.fieldStyle === "text-field-dashed" && /*#__PURE__*/_react["default"].createElement("svg", {
    className: "svg-dashed {{ classes }}",
    height: "1px",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("line", {
    x1: "0",
    y1: "1",
    x2: "400",
    y2: "1",
    stroke: "black"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "field-message ".concat(message ? "show" : "")
  }, message), valid === "error" && /*#__PURE__*/_react["default"].createElement(_TooltipCoachmark["default"], {
    isControlled: true,
    type: "coachmark-icon",
    position: "right",
    context: ".".concat(fieldClassToUse),
    state: "show",
    color: "red"
  }, /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
    name: "glyph-error",
    className: "the-svg-icons"
  })), valid === "empty" && /*#__PURE__*/_react["default"].createElement(_TooltipCoachmark["default"], {
    isControlled: true,
    type: "coachmark-icon",
    position: "right",
    context: ".".concat(fieldClassToUse),
    state: "show",
    color: "grey"
  }, /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
    name: "glyph-arrow",
    className: "the-svg-icons"
  }))));
};

TextField.propTypes = {
  type: _propTypes["default"].oneOf(["text", "email", 'password', "url", "search", "tel", "location", "number"]),
  name: _propTypes["default"].string,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  maxLength: _propTypes["default"].number,
  placeholder: _propTypes["default"].string,
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  valid: _propTypes["default"].oneOf(["valid", "error", 'disabled', 'empty', ""]),
  message: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  required: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  autoSelectOnFocus: _propTypes["default"].bool,
  tabIndex: _propTypes["default"].number,
  id: _propTypes["default"].string,
  fieldStyle: _propTypes["default"].oneOf(["text-field-outline", "text-field-dashed", "text-field-boxed"]),
  autoComplete: _propTypes["default"].oneOf(['on', 'off', 'false', 'new-password']),
  width: _propTypes["default"].string,
  timeoutOptions: _propTypes["default"].oneOfType([_propTypes["default"].shape({
    time: _propTypes["default"].number,
    callback: _propTypes["default"].func
  }), _propTypes["default"].bool]),
  customValue: _propTypes["default"].object
};
TextField.defaultProps = {
  type: "text",
  name: "",
  value: "",
  maxLength: 255,
  placeholder: null,
  valid: "",
  message: null,
  required: false,
  onChange: function onChange() {},
  onBlur: function onBlur() {},
  className: "",
  style: {},
  tabIndex: 1,
  id: null,
  fieldStyle: "text-field-outline",
  autoComplete: 'new-password',
  timeoutOptions: null,
  customValue: null
};
var _default = TextField;
exports["default"] = _default;